export default __webpack_public_path__ + "static/media/scratch.84471df7.png";